import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MobileProvider } from './mobile-provider.model';

@Injectable({
    providedIn: 'root'
})
export class MobileProviderService {
    uri = `${environment.apiLocation}/MobileProvider`;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    get(): Observable<Array<MobileProvider>> {
        return this.http.get<Array<MobileProvider>>(this.uri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'MobileProviderService:reponse',
                    res
                })
            )
        );
    }
}
